import { render, staticRenderFns } from "./MenuManage.vue?vue&type=template&id=e9895b2c&scoped=true"
import script from "./MenuManage.vue?vue&type=script&lang=js"
export * from "./MenuManage.vue?vue&type=script&lang=js"
import style0 from "./MenuManage.vue?vue&type=style&index=0&id=e9895b2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9895b2c",
  null
  
)

export default component.exports